export const labelClass = 'mb-1 block text-sm font-medium text-gray-700';

const inputBaseClass =
  'h-9 rounded-lg border border-gray-300 px-3 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500';

export const inputClass = `${inputBaseClass} w-full`;

export const selectClass = inputClass;

export const inputGroupLeftClass = `${inputBaseClass} min-w-0 flex-1 rounded-r-none border-r-0`;

export const inputGroupRightClass = `${inputBaseClass} w-24 shrink-0 rounded-l-none border-l-0`;

export const textareaClass =
  'w-full resize-y rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500';

export const hintClass = 'mt-1 min-h-[1.125rem] text-xs text-gray-500';

export const fieldGridClass = 'grid grid-cols-1 gap-x-4 gap-y-3 md:grid-cols-2';

export const btnSecondary =
  'rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50';

export const btnPrimary =
  'rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-50';
